<template>
  <footer class="footer">
    <span>{{ $t("page.footer.text1") }}</span>
    <img src="@/assets/ico-world.png" />
    <span>{{ $t("page.footer.text2") }}</span>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
}
</script>
